const IS_LOADING = "movies/IS_LOADING";
const IS_PARTIAL_LOADING = "movies/IS_PARTIAL_LOADING";
const IS_ERROR = "movies/IS_ERROR";
const MOVIES = "movies/MOVIES";
const MOVIE = "movies/MOVIE";
const MOVIE_SCREENS = "movies/MOVIE_SCREENS";
const MOVIE_THEATRES = "movies/MOVIE_THEATRES";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, MOVIES, MOVIE, MOVIE_SCREENS, MOVIE_THEATRES };
